import reducer from "./reducer";
export { default as PermissionsSettings } from "./components/index";
export { default as permissionsSettingsReducerName } from "./constants";
export default reducer;
